var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { row: "", wrap: "", "fill-width": "" } },
    [
      _c("DateRange", {
        attrs: { box: "", "no-arrows": "", "max-date": _vm.maxDate },
        model: {
          value: _vm.dates,
          callback: function ($$v) {
            _vm.dates = $$v
          },
          expression: "dates",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }